import React, { useState } from 'react'; 
import './blog-post.css'; 
import './blog-slides.css';  
//pictures here
import recap1 from './pictures/swegamenight.jpg';  
import recap2 from './pictures/swegamenight2.jpg'; 

const Game = () => {
  return (
    <div>
      <div className='blog__container'>
        <div className="row">
          <div className="column">
                <header></header>
            <section>
              <h2>WiC x SWE Game Night!</h2>
              <p className="site-post-meta">May 7, 2025</p>
              <hr />
            </section>
            <section>
              <p>

              Hi WiC!

<br></br>
<br></br>

Thanks to everyone who came to our WiC x SWE Game Night this past Wednesday! We had a lot fun getting to know you all while playing UW-themed Jeopardy! Shoutout to the winners, who won gift cards to Lune Cafe. :)

<br></br>
<br></br>


                
              </p>
              <img src={recap1} alt="Recap 1" />
              <img src={recap2} alt="Recap 2" />
              
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Game;